import { connect } from 'react-redux';
import { compose, applySpec } from 'ramda';

import OrganizationForm from 'components/OrganizationForm';
import withPageLoader from 'components/withPageLoader';

import { requestPractitioners } from 'store/actionCreators/practitioners';
import { getPractitionersShouldShowLoading } from 'store/selectors/practitioners';
import { addOrganizations } from 'store/actionCreators/organizations';
import {
  initOrganizationEdit,
  initEditSuperCareteamUsers,
  fetchOrganization,
} from 'store/actionCreators/organization';

import {
  getSiteId,
  getOrganizationName,
  getParticipantIdObject,
  getOrganizationFetchingStatus,
  isSuperCareteam,
} from 'store/selectors/organization';

export const AddOrganization = compose(
  withPageLoader({
    loadingSelector: getPractitionersShouldShowLoading,
    initialAction: requestPractitioners,
  }),
  connect(
    undefined,
    { handleSubmit: addOrganizations },
  ),
)(OrganizationForm);

export const EditOrganization = compose(
  withPageLoader({
    loadingSelector: getOrganizationFetchingStatus,
    initialAction: fetchOrganization,
  }),
  connect(
    applySpec({
      initialValues: applySpec({
        siteId: getSiteId,
        name: getOrganizationName,
        participants: getParticipantIdObject,
      }),
      isSuperCareteam,
    }),
    (dispatch, { isSuperCareteam: isSuper }) => ({
      handleSubmit: isSuper
        ? () => dispatch(initEditSuperCareteamUsers())
        : () => dispatch(initOrganizationEdit()),
    }),
  ),
)(OrganizationForm);
